'use client';

import { Box, Typography, useTheme } from '@mui/material';
import { Area, AreaChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

import { colors } from '@/styles/theme';
import { formatCurrency } from '@/utils';

interface ChartDataPoint {
  name: string;
  displayDate: string;
  value: number;
}

interface ProfitLossChartProps {
  data: ChartDataPoint[];
}

export const ProfitLossChart = ({ data }: ProfitLossChartProps) => {
  const theme = useTheme();
  return (
    <Box sx={{ height: 140, width: '100%', ml: -2 }}>
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={data}>
          <XAxis dataKey="displayDate" hide />
          <YAxis hide domain={['auto', 'auto']} />
          <defs>
            <linearGradient id="colorValue" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor={colors.accent.blue[600]} stopOpacity={0.3} />
              <stop offset="95%" stopColor={colors.accent.blue[600]} stopOpacity={0} />
            </linearGradient>
          </defs>
          <Area
            type="monotone"
            dataKey="value"
            stroke={colors.accent.blue[600]}
            strokeWidth={3}
            fillOpacity={1}
            fill="url(#colorValue)"
          />
          <Tooltip
            content={({ active, payload }) => {
              if (active && payload && payload.length) {
                return (
                  <Box
                    sx={{
                      bgcolor: 'background.paper',
                      p: 1,
                      borderRadius: 1,
                      border: '1px solid',
                      borderColor: 'divider',
                      boxShadow: theme.shadows[4],
                    }}
                  >
                    <Typography variant="caption" sx={{ color: 'text.primary', fontWeight: 600 }}>
                      {formatCurrency(payload[0].value as number)}
                    </Typography>
                  </Box>
                );
              }
              return null;
            }}
          />
        </AreaChart>
      </ResponsiveContainer>
    </Box>
  );
};
